import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><img parentName="p" {...{
        "src": "/reevesdotnl/30e566f93f6afbb591de49ac5e653f28/fixed-aug27.gif",
        "alt": "fixed hotspot animation"
      }}></img></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../animations"
        }}>{`Select another animation`}</a></li>
    </ul>
    <p>{`Global tectonics for Gondwana is not so much about continents moving as about oceans - or their mid-ocean ridges at least - staying in the same place.
A number of mantle plumes are thought to have remained fixed with respect to the earth's rotation axis and hence provide a fixed reference frame for the movements
of all the continents.  These plumes have each provided geological evidence of (a) an abrupt outbreak with copious supplies of magma at a certain time and (b) a
`}<strong parentName="p">{`trail`}</strong>{` of generally diminishing activity (perhaps with some reactivations from time to time) in the form of oceanic islands and submarine edifices lying on the
oceanic crust. Mid-ocean ridges, meanwhile, can be shown to have been always located close to the mid-point between separating continents.  The resulting combined model, improved incremenally over many years, is shown in the animation for the period from 200 Ma to the present-day during which the Gondwana continents dispersed. What emerges is the pattern by which the growing network of mid-ocean ridges is closely related to the constellation of hotspots across the hemisphere that Gondwana and its oceans now occupy.`}</p>
    <p>{`The present-day continental coastlines are shown by dashed lines.`}</p>
    <p>{`Note in particular the central role of the Bouvet mantle plume which is generally overlooked in the literature. The rationale behind our global reference frame rotation model was explained in Research Update No.21 in July 2022.  The new rotation parameters for a smoother movement for Africa over this time-frame were added to page 6 of this Update on 2025 July 28. Note the white dot with blue outline near the Bouvet plume head in the animation above.  This indicates the position of the Bouvet hotspot with respect to Africa according to the hotspot system 0-124 Ma published by Doubrovine et al (2012). These authors examined the record of all the world's hotspots while omitting the Bouvet plume.  It is the Bouvet plume that we place centrally in the story of Gondwana dispersal.  Our two frames never differ by more than 400 km but the movements of the white dot in the figure above show that our model has a smoother movement for Africa.  Our movement for Africa may be summarised (for a point in equatorial central Africa) as 16 km/My to the NNE 200-140 Ma, 27 km/My more to the NE 140-80 Ma and 20 km/My going NE 80-0 Ma.`}</p>
    <p><em parentName="p">{`Reference`}</em></p>
    <p><em parentName="p">{`Pavel V. Doubrovine, Bernhard Steinberger and Trond H. Torsvik, 2012. Absolute plate motions in a reference frame defined by moving hot spots in the Pacific, Atlantic, and Indian oceans. `}<a parentName="em" {...{
          "href": "https://doi.org/10.1029/2011JB009072"
        }}>{`Journal of Geophysical Research`}</a></em></p>
    <p><em parentName="p">{`Last update: 2025 August 27`}</em></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../animations"
        }}>{`Select another animation`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../gondwana"
        }}>{`Return to Gondwana main page`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      